import { BsInfoCircleFill as InfoCircleFillIcon } from 'react-icons/bs';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LockIcon from '@mui/icons-material/Lock';
import PlaceIcon from '@mui/icons-material/Place';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveIcon from '@mui/icons-material/Remove';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import StarIcon from '@mui/icons-material/Star';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

import { ReactComponent as AddBookmarkIcon } from '../assets/icons/add-bookmark.svg';
import { ReactComponent as LightBulbIcon } from '../assets/icons/light-bulb-icon.svg';
import { ReactComponent as AddressDownloadIcon } from '../assets/icons/address-download.svg';
import { ReactComponent as AlphabetIcon } from '../assets/icons/alphabet.svg';
import { ReactComponent as AttentionIcon } from '../assets/icons/attention-icon.svg';
import { ReactComponent as BackIcon } from '../assets/icons/back.svg';
import { ReactComponent as BalanceRedIcon } from '../assets/icons/balance-red.svg';
import { ReactComponent as BalanceIcon } from '../assets/icons/balance.svg';
import { ReactComponent as BeautyPassIcon } from '../assets/icons/beautypass-icon.svg';
import { ReactComponent as BeautyPassWhiteIcon } from '../assets/icons/beautypass-white-icon.svg';
import { ReactComponent as BlockedUserIcon } from '../assets/icons/blocked-user.svg';
import { ReactComponent as CalendarIcon } from '../assets/icons/calendar.svg';
import { ReactComponent as ChangeIcon } from '../assets/icons/change.svg';
import { ReactComponent as ChatIcon } from '../assets/icons/chat.svg';
import { ReactComponent as UndoIcon } from '../assets/icons/undo.svg';
import { ReactComponent as CheckboxIcon } from '../assets/icons/checkbox-icon.svg';
import { ReactComponent as CollabMessageIcon } from '../assets/icons/collab-message.svg';
import { ReactComponent as CollabOfferIcon } from '../assets/icons/collabOffer.svg';
import { ReactComponent as Content1StoryIcon } from '../assets/icons/content-1Story.svg';
import { ReactComponent as ContentFeedIcon } from '../assets/icons/content-feed.svg';
import { ReactComponent as ContentReelIcon } from '../assets/icons/content-reel.svg';
import { ReactComponent as CopyIcon } from '../assets/icons/copy.svg';
import { ReactComponent as CountryIcon } from '../assets/icons/country.svg';
import { ReactComponent as CrossIcon } from '../assets/icons/cross-icon.svg';
import { ReactComponent as DeleteIcon } from '../assets/icons/delete.svg';
import { ReactComponent as DollarSignV3Icon } from '../assets/icons/dollar-sign-v3.svg';
import { ReactComponent as DollarSignIcon } from '../assets/icons/dollar-sign.svg';
import { ReactComponent as DollarSignV2Icon } from '../assets/icons/dollar-v2.svg';
import { ReactComponent as DragHandIcon } from '../assets/icons/drag-hand.svg';
import { ReactComponent as EventOfferIcon } from '../assets/icons/event-offer.svg';
import { ReactComponent as ExtraContentIcon } from '../assets/icons/extra-content.svg';
import { ReactComponent as FiltersIcon } from '../assets/icons/filters.svg';
import { ReactComponent as GridIconV2 } from '../assets/icons/grid-icon.svg';
import { ReactComponent as GridIcon } from '../assets/icons/grid.svg';
import { ReactComponent as HeartIcon } from '../assets/icons/heart.svg';
import { ReactComponent as HistoryIcon } from '../assets/icons/history.svg';
import { ReactComponent as InfoLightIcon } from '../assets/icons/info-light.svg';
import { ReactComponent as InfoIcon } from '../assets/icons/info.svg';
import { ReactComponent as InstagramIcon } from '../assets/icons/instagram.svg';
import { ReactComponent as ListIconV2 } from '../assets/icons/list-icon.svg';
import { ReactComponent as ListIcon } from '../assets/icons/list.svg';
import { ReactComponent as MessageIcon } from '../assets/icons/message.svg';
import { ReactComponent as MinusIcon } from '../assets/icons/minus.svg';
import { ReactComponent as NoChatIcon } from '../assets/icons/no-chat.svg';
import { ReactComponent as NoMemberIcon } from '../assets/icons/no-member.svg';
import { ReactComponent as NoRequirementIcon } from '../assets/icons/no-requirement.svg';
import { ReactComponent as PaidCollabV2Icon } from '../assets/icons/paid-collab-v2.svg';
import { ReactComponent as PostContentIcon } from '../assets/icons/posts-content.svg';
import { ReactComponent as ReceivePostIcon } from '../assets/icons/receive-post.svg';
import { ReactComponent as ReceiveUserIcon } from '../assets/icons/receive-user.svg';
import { ReactComponent as RecruitOfferIcon } from '../assets/icons/recuritingOffer.svg';
import { ReactComponent as RecurringOfferV2Icon } from '../assets/icons/recurring-offer-v2.svg';
import { ReactComponent as RemoveBookmarkIcon } from '../assets/icons/remove-bookmark.svg';
import { ReactComponent as ReservationIcon } from '../assets/icons/reservation.svg';
import { ReactComponent as SecureIcon } from '../assets/icons/secure.svg';
import { ReactComponent as SelectedTickIcon } from '../assets/icons/selected-tick.svg';
import { ReactComponent as Sent2xIcon } from '../assets/icons/sent2x.svg';
import { ReactComponent as ShippmentIcon } from '../assets/icons/shippment.svg';
import { ReactComponent as ShopifyIcon } from '../assets/icons/shopify-icon.svg';
import { ReactComponent as SpecialOfferIcon } from '../assets/icons/specialOffer.svg';
import { ReactComponent as StarV2Icon } from '../assets/icons/star.svg';
import { ReactComponent as StatsIcon } from '../assets/icons/stats.svg';
import { ReactComponent as StripeIcon } from '../assets/icons/stripe-icon.svg';
import { ReactComponent as SupportIcon } from '../assets/icons/support.svg';
import { ReactComponent as TickIcon } from '../assets/icons/tick-icon.svg';
import { ReactComponent as TickWhiteIcon } from '../assets/icons/tick-white.svg';
import { ReactComponent as TwoWayArrowIcon } from '../assets/icons/two-way-arrow-icon.svg';
import { ReactComponent as UsageBadgeIcon } from '../assets/icons/usage-badge.svg';
import { ReactComponent as UsageRightsIcon } from '../assets/icons/usage-rights.svg';
import { ReactComponent as GiftingIcon } from '../assets/icons/v2/gifting-icon.svg';
import { ReactComponent as InstagramActiveV2Icon } from '../assets/icons/v2/instagram-active-icon-v2.svg';
import { ReactComponent as InstagramIconV2 } from '../assets/icons/v2/instagram-icon-v2.svg';
import { ReactComponent as TiktokIcon } from '../assets/icons/v2/tiktok-icon.svg';
import { ReactComponent as VideoIcon } from '../assets/icons/video.svg';
import { ReactComponent as WarningIcon } from '../assets/icons/warning.svg';

export default {
  ChatIcon,
  DoneAllIcon,
  CollabOfferIcon,
  RecruitOfferIcon,
  SpecialOfferIcon,
  PlaceRoundedIcon,
  AddIcon,
  PlayArrowIcon,
  AttentionIcon,
  StatsIcon,
  InfoIcon,
  VideoIcon,
  MessageIcon,
  HeartIcon,
  CountryIcon,
  EventOfferIcon,
  BalanceIcon,
  CloseIcon,
  UsageBadgeIcon,
  InfoCircleFillIcon,
  CollabMessageIcon,
  ReceivePostIcon,
  ReceiveUserIcon,
  DollarSignIcon,
  StripeIcon,
  BeautyPassIcon,
  BeautyPassWhiteIcon,
  TwoWayArrowIcon,
  LockIcon,
  InfoLightIcon,
  SendIcon,
  BalanceRedIcon,
  CalendarIcon,
  DeleteIcon,
  NoChatIcon,
  NoRequirementIcon,
  GridIcon,
  ListIcon,
  StarIcon,
  CrossIcon,
  TickIcon,
  NoMemberIcon,
  ShippmentIcon,
  InstagramIcon,
  SupportIcon,
  AddBookmarkIcon,
  RemoveBookmarkIcon,
  RefreshIcon,
  PostContentIcon,
  UsageRightsIcon,
  ExtraContentIcon,
  Content1StoryIcon,
  ContentFeedIcon,
  ContentReelIcon,
  MinusIcon,
  BlockedUserIcon,
  RecurringOfferV2Icon,
  PaidCollabV2Icon,
  BackIcon,
  AlphabetIcon,
  SelectedTickIcon,
  Sent2xIcon,
  TickWhiteIcon,
  ChangeIcon,
  GridIconV2,
  ListIconV2,
  DollarSignV2Icon,
  SecureIcon,
  StarV2Icon,
  WarningIcon,
  ReservationIcon,
  ExpandMoreIcon,
  EditIcon,
  SearchIcon,
  TuneOutlinedIcon,
  HistoryIcon,
  FiltersIcon,
  DragHandIcon,
  PlaceIcon,
  CopyIcon,
  ShopifyIcon,
  CheckboxIcon,
  RemoveIcon,
  InstagramActiveV2Icon,
  InstagramIconV2,
  TiktokIcon,
  GiftingIcon,
  DollarSignV3Icon,
  AddressDownloadIcon,
  LightBulbIcon,
  UndoIcon,
};
